import React, {useState, useEffect} from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import authService from './services/authService';
import Login from './components/Login';
import Home from './components/Home'; 
import Demographics from './components/Demographics';
import FirstMentionAwareness from './components/FirstMentionAwareness';
import TotalAwareness from './components/TotalAwareness';
import CurrentBankUsage from './components/CurrentBankUsage';
import MainBankUsageMarketShare from './components/MainBankUsageMarketShare'
import ProductMarketShare from './components/ProductMarketShare';
import BankConsideration from './components/BankConsideration';
import BankPreference from './components/BankPreference';
import ProductPreference from './components/ProductPreference';
import ImageryPerceptions from './components/ImageryPerceptions';
import ChannelInteraction from './components/ChannelInteraction';
import PowerPointComponent from './components/PowerPoint';
import MainBankUsagePPTX from './powerpoint/MainBankUsagePPTX'
import DemographicsPPTX from './powerpoint/DemographicsPPTX';
import BankPreferencePPTX from './powerpoint/BankPreferencePPTX';
import FirstMentionPPTX from './powerpoint/FirstMentionPPTX';
//import ProtectedRoute from './components/ProtectedRoute';

const PrivateRoute = ({ element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    authService.isAuthenticated()
      .then(authenticated => {
        setIsAuthenticated(authenticated);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) return <div>Loading...</div>;
  return isAuthenticated ? element : <Navigate to="/" replace />;
};


function App() {

  //const isAuthenticated = !!authService.getCurrentUser();


  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<PrivateRoute element={<Home />} />} />
        <Route path="/demographics" element={<PrivateRoute element={ <Demographics heading="Demographics" gender="Gender" race="Race" age="Age" working_status = "Working Status" employment_status = "Employment Status"/> } />} />        
        <Route path="/first-mention-awareness" element={<PrivateRoute element={<FirstMentionAwareness heading="Spontaneous First Mention Awareness" total="Total" total_youth = "Total Youth, Mass & Middle Market" total_private="Total Private" prestige="Prestige Banking" private_only="Private Banking" youth="Youth" middle_market="Middle Market" mass_market="Mass Market"/>} />} />   
        <Route path="/total-awareness" element={<PrivateRoute element={<TotalAwareness heading="Total Awareness" total="Total" total_youth = "Total Youth, Mass & Middle Market" total_private="Total Private" prestige="Prestige Banking" private_only="Private Banking" youth="Youth" middle_market="Middle Market" mass_market="Mass Market"/>} />}/>   
        <Route path="/current-bank-usage" element={<PrivateRoute element={<CurrentBankUsage heading="Current Bank Usage" total="Total" total_youth = "Total Youth, Mass & Middle Market" total_private="Total Private" prestige="Prestige Banking" private_only="Private Banking" youth="Youth" middle_market="Middle Market" mass_market="Mass Market" />} />} />  
        <Route path="/main-bank-usage-market-share" element={<PrivateRoute element={<MainBankUsageMarketShare heading="Main Bank Usage Market Share" total="Total" total_youth = "Total Youth, Mass & Middle Market" total_private="Total Private" prestige="Prestige Banking" private_only="Private Banking" youth="Youth" middle_market="Middle Market" mass_market="Mass Market"/>} />} />         
        <Route path="/product-market-share" element={<PrivateRoute element={<ProductMarketShare heading="Product Market Share" savings="Savings" cheque = "Cheque" credit_card="Credit Card" home_loan="Home Loan" vaf="VAF"/>} />} />   
        <Route path="/bank-consideration" element={<PrivateRoute element={<BankConsideration heading="Bank Consideration" total="Total" total_youth = "Total Youth, Mass & Middle Market" total_private="Total Private" prestige="Prestige Banking" private_only="Private Banking" youth="Youth" middle_market="Middle Market" mass_market="Mass Market"/>} />} />
        <Route path="/bank-preference" element={<PrivateRoute element={<BankPreference heading="Bank Preference" total="Total" total_youth = "Total Youth, Mass & Middle Market" total_private="Total Private" prestige="Prestige Banking" private_only="Private Banking" youth="Youth" middle_market="Middle Market" mass_market="Mass Market"/>} />} />  
        <Route path="/product-preference" element={<PrivateRoute element={<ProductPreference heading="Product Preference" savings="Savings" cheque = "Cheque" credit_card="Credit Card" home_loan="Home Loan" vaf="VAF"/>} />} />  
        <Route path="/imagery-perceptions" element={<PrivateRoute element={<ImageryPerceptions
         heading="Imagery Perception"
         possible_for_you = "Speaks of what could be possible for you"
         easy_to_deal_with = "Is easy to deal with"
         responds_to_needs = "Responds to what you need"
         new_ways = "Finds new ways to do things"
         aspirations = "Supports your aspirations"
         trustworthy = "Is trustworthy"
         uses_technology = "Uses technology to make banking easier"
         leader_personal_banking = "Is a leader in personal banking in South Africa"
         leading_organisation = "Is a leading organisation"
         products_and_opportunities = "Offers relevant products and opportunities throughout your growth"
         valuable_partner = "Is a valuable partner"
         drives_sa_growth = "Is a bank that drives South Africa's growth"
         confident = "Is confident"
         motivates_to_grow = "Motivates you to want to grow more"
         understands_you = "Understands you and what matters to you"
         />} />}/>   
        <Route path="/channel-interaction" element={<PrivateRoute element={<ChannelInteraction heading="Channel Interaction"/>} />} />           
      </Routes>
    </BrowserRouter>
  );
}

export default App;
